import { Button } from '@interco/inter-ui/components/Button'
import { Page } from '@templates'
import { Timer } from '@signals'
import { useTrackingRefin } from '@hooks'
import { StepRefin } from '@utils/enums'
import { Content, IconWrapper, Title, Subtitle } from '@organisms/INSSIndisponivel/styles'

import { useEntendiRedirect, useServicoIndisponivelTracking } from './helpers'

const ServicoIndisponivel = () => {
  useTrackingRefin(StepRefin.SERVICO_INDISPONIVEL)
  useServicoIndisponivelTracking()
  const handleEntendi = useEntendiRedirect()

  return (
    <Page
      showLeftIcon={false}
      stickyFooter={
        <Button variant="primary" aria-label="Entendi" onClick={handleEntendi}>
          Entendi
        </Button>
      }
    >
      <Content>
        <IconWrapper aria-hidden="true">
          <Timer />
        </IconWrapper>
        <Title>Serviço indisponível</Title>
        <Subtitle>
          Entre os dias 20 e 23, devido atualização da folha de pagamento. Por favor, acesse após
          esse período.
        </Subtitle>
      </Content>
    </Page>
  )
}

export default ServicoIndisponivel
